<template>
    <div class="table-simple-modal" style="max-height: 50vh; overflow-y: auto;">

        <b-table-simple responsive bordered>
            <b-thead>
                <b-tr>
                    <b-th>Period</b-th>
                    <b-th>Interest Charged (RM)</b-th>
                    <b-th>Principal (RM)</b-th>
                    <b-th>Instalment (RM)</b-th>
                    <b-th>Balance (RM)</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index" class="text-right">
                    <template v-if="index != 'paid_off_month'">
                        <b-td>{{ index }}</b-td>
                        <b-td>{{ item["interest_charged"] | moneyFormatter }}</b-td>
                        <b-td>{{ item["principal"] | moneyFormatter }}</b-td>
                        <b-td>{{ item["instalment"] | moneyFormatter }}</b-td>
                        <b-td>{{ item["balance"] | moneyFormatter }}</b-td>
                    </template>
                </b-tr>
            </b-tbody>
            <b-tfoot>
                <b-tr class="bg-dark text-right">
                    <b-td class="text-white">Total</b-td>
                    <b-td class="text-white">{{ totalData.total_interest_charged | moneyFormatter }}</b-td>
                    <b-td class="text-white">{{ totalData.total_principal | moneyFormatter }}</b-td>
                    <b-td class="text-white">{{ totalData.total_instalment | moneyFormatter }}</b-td>
                    <b-td class="text-white"></b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
    </div>
</template>
<script>
export default {
    props: {
        tableData: Array,
        totalData: Object
    }
}
</script>